import "./style.css";
import { directive as T } from "./index-DUPC5men-DaO0oGZM-DikaOSB0.js";
import { UnsafeHTMLDirective as r } from "./index-K3rW__Pr-Dq70wvfy-Cnwjc6Nk.js";
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
class e extends r {
}
e.directiveName = "unsafeSVG", e.resultType = 2;
const o = T(e);
export {
  o as unsafeSVG
};
